import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Data } from '@angular/router';

import { PainelFinanceiroApiService } from '../services/painel-financeiro-api.service';
import { OrigemLancamento } from '../../../../shared/models/enums/origem-lancamento';
import { MatDialog } from '@angular/material/dialog';
import { ContaBancoVincularAoCaixaManual } from '../../configuracao-caixa/models/conta-banco-vincular-ao-caixa-manual';
import { MessageService } from '@services/message.service';
import { DialogConfirmacaoComponent } from '@components/dialog-confirmacao/dialog-confirmacao.component';
import { ImportLancamentosService } from '@services/import-lancamentos.service';
import { ContaCaixa } from '../models/conta-caixa';
import { Permissao } from '@models/enums/permissao';
import { TipoContaBancoEnum } from '../../../../shared/models/enums/tipo-conta-banco-enum';

@Component({
  selector: 'app-painel-financeiro',
  templateUrl: './painel-financeiro.component.html',
  styleUrl: './painel-financeiro.component.scss',
  standalone: false,
})
export class PainelFinanceiroComponent implements OnInit {

  excelFileType: string = ".xlsx";
  csvFileType: string = ".csv";
  origemLancamentoBanco: OrigemLancamento = OrigemLancamento.Banco;
  origemLancamentoCaixa: OrigemLancamento = OrigemLancamento.Caixa;
  tipoContaBancoCartao: TipoContaBancoEnum = TipoContaBancoEnum.CartaoCredito;

  contasBanco: ContaBancoVincularAoCaixaManual[] = [];
  contasCaixa: ContaCaixa[] = [];

  protected get permissaoVisualizarConciliacao() { return Permissao.VISUALIZAR_CONCILIACAO; }

  constructor(
    private painelFinanceiroApiService: PainelFinanceiroApiService,
    private route: ActivatedRoute,
    private dialog: MatDialog,
    private messageService: MessageService,
    private importConciliacaoService: ImportLancamentosService,
  ) { }

  ngOnInit(): void {
    this.route.data.subscribe((data: Data) => {
      const dados = data['painelFinanceiro'];
      this.contasBanco = dados.contasBanco;
      this.contasCaixa = dados.contasCaixa;
    });
  }

  public importLancamentos(inputElement: HTMLInputElement, conta: ContaBancoVincularAoCaixaManual, origem: OrigemLancamento): void {
    this.importConciliacaoService.importLancamentos(inputElement, conta.id, origem, conta.tipoContaBanco);
  }

  public importarConciliacao(inputElement: HTMLInputElement): void {
    const file: File | null = inputElement.files === null ? null : inputElement.files[0];
    inputElement.value = '';

    if (!file) return;

    this.painelFinanceiroApiService.criarContaBancoImportandoConciliacao(file).subscribe({
      next: () => {
        this.messageService.showToastSuccess("Conta criada com sucesso.");
      }
    });
  }
}
